<app-modal
  [title]="'ADMIN.MAIL_ACCOUNTS.DELETE_CONFIRM_TITLE'"
  [closeText]="'CANCEL'"
  [submitText]="'DELETE'"
  (submitClicked)="modalRef.close(true)">
  <p class="mb-0">{{ 'ADMIN.MAIL_ACCOUNTS.DELETE_CONFIRM_MESSAGE' | translate: { name: accountName } }}</p>
  <div class="alert alert-danger fw-bold mt-3 mb-0" role="alert">
    {{ 'ADMIN.MAIL_ACCOUNTS.DELETE_CONFIRM_ARCHIVED_MAILS_WARNING' | translate }}
  </div>
</app-modal>
